import firebase from "firebase/app";
import "firebase/storage";
import "firebase/auth";
require("firebase/firestore");
require("firebase/functions")
 
const firebaseConfig = {
  apiKey: "AIzaSyChzwTh66_UHp9m9hmcLHY0Y9GVqhYd_og",
  authDomain: "k5-prod.firebaseapp.com",
  projectId: "k5-prod",
  storageBucket: "k5-prod.appspot.com",
  messagingSenderId: "637639040608",
  appId: "1:637639040608:web:87d68aa854b104d829ad05",
  measurementId: "G-8RD5DTWST5"
};
  // Initialize Firebase
  firebase.initializeApp(firebaseConfig);
 
  
  //firebase.analytics();
const storage = firebase.storage();
// Initialize Cloud Functions through Firebase
var functions = firebase.functions();
const timestamp = firebase.firestore.Timestamp;
// const firestore = firebase.firestore;
// const timestamp = new Date().getTime();
export { storage, firebase, timestamp  };